import {define, init, inject, singleton} from '@injex/core';
import SocketManager from '../../../../../common/managers/SocketManager.mdl';
import BaseScheduleReportModel from '../../common/base/BaseScheduleReportModel';
import {IScheduleReport} from '../../../interfaces/IScheduleReport';
import {observable} from "mobx";
import IReportingFilterHandler from "../../../../../common/reporting-filters/interfaces/IReportingFilterHandler";
import {guid} from '@vidazoo/ui-kit';
import UrlsService from '../../../../../common/router/services/urlsService.mdl';

@define()
export class ScheduleReportEditModel extends BaseScheduleReportModel {

    @inject() socketManager: SocketManager;
    @observable public filters: IReportingFilterHandler[] = [];

    @init()
    protected initialize() {
        super.initialize();
        this.item.hooks.fetchCompleted.tapAsync(() => this._onFetchCompleted());
    }

    public get data() {
        return [];
    }

    private async _onFetchCompleted() {
        const aliases = {publisherId: 'publisherName', scenarioId: 'scenarioName', connectionId: 'connectionName', tagId: 'tagName', abTestId: 'abTestName'};
        for (const filter of this.item.data.filters) {
            filter.id = filter.id || guid();
            const values = filter.values || [];
            await this.setFilterKey(filter, aliases[filter.key] || filter.key);
            const handler = this.reportingFiltersManager.getFilter(filter.key, this.item.data.verticalType);
            filter.values = values.map(value => {
                if (!filter.filterValueKey || typeof value === 'object') return value;
                return {[filter.filterValueKey]: value, [filter.filterLabelKey]: handler.getLabelByValue(value) || value};
            });
        }
    }

    public async fetchItem(id: string): Promise<IScheduleReport> {
        const item = await this.apiManager.scheduleReports.getById(id, {});
        if (item.timezone === 'Etc/GMT') item.timezone = 'Etc/GMT+0';
        item.constraints = (item.constraints || []).map(constraint => ({...constraint, id: constraint.id || guid(), op: constraint.op === '==' ? '=' : constraint.op}));
        item.filters = item.filters || [];
        return item;
    }

    public submit = async () => {
        try {
            await this.apiManager.scheduleReports.updateById(this.item.data._id, this.submitify());
            this.onSubmitSuccess();

        } catch (err) {
            this.onSubmitFailed(err);
        }
    }

    public delete = async () => {
        try {
            await this.apiManager.scheduleReports.deleteById(this.item.data._id);
            this.onDeleteSuccess();
            this.routerService.push(UrlsService.scheduleReports());

        } catch (e) {
            this.onDeleteError(e);
        }
    }
}
